module.exports = __webpack_public_path__ + "img/icon-enabled-acc.479d56c3.svg";